var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 21.8888H5C4.44772 21.8888 4 21.4411 4 20.8888V11.8888H1L11.3273 2.50029C11.7087 2.15355 12.2913 2.15355 12.6727 2.50029L23 11.8888H20V20.8888C20 21.4411 19.5523 21.8888 19 21.8888ZM13 19.8888H18V10.0462L12 4.59169L6 10.0462V19.8888H11V13.8888H13V19.8888Z",
    fill: "#251169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.5176694f0fce6881ec44079a44506943.svg";
export { ForwardRef as ReactComponent };